<template>
  <v-container>
    <div
      class="mt-5"
      :class="{'mx-10': $vuetify.breakpoint.lgAndUp}"
      style="border:1px solid black"
    >
      <v-tabs
        ref="tabs"
        v-model="active"
        align-with-title
        slider-color="white"
        show-arrows
      >
        <v-tab
          v-for="item in filteredTabItems"
          :key="item.name"
          class="divider font-black"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="active">
        <v-tab-item
          v-if="$hasPermissionTo(['view payroll cycles'])"
          class="pb-12"
        >
          <setup-payroll-payroll-cycle-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view payroll banks'])"
          class="pb-12"
        >
          <setup-payroll-payroll-bank-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view contribution or deductions'])"
          class="pb-12"
        >
          <setup-payroll-contribution-or-deduction-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view tax exemptions'])"
          class="pb-12"
        >
          <setup-payroll-tax-exemption-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view tax reliefs'])"
          class="pb-12"
        >
          <setup-payroll-tax-relief-container-view />
        </v-tab-item>
       
        <v-tab-item
          v-if="$hasPermissionTo(['view cut off types'])"
          class="pb-12"
        >
          <setup-payroll-cutoff-type-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view DoEs'])"
          class="pb-12"
        >
          <setup-payroll-doe-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view benefit in kinds'])"
          class="pb-12"
        >
          <setup-payroll-bik-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view perquisites'])"
          class="pb-12"
        >
          <setup-payroll-perquisite-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view volas'])"
          class="pb-12"
        >
          <setup-payroll-vola-container-view />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupPayrollPayrollCycleContainerView: () => import('@/components/hris/setup/payroll/payroll-cycle/ContainerView'),
      SetupPayrollPayrollBankContainerView: () => import('@/components/hris/setup/payroll/payroll-bank/ContainerView'),
      SetupPayrollTaxReliefContainerView: () => import('@/components/hris/setup/payroll/tax-relief/ContainerView'),
      SetupPayrollCutoffTypeContainerView: () => import('@/components/hris/setup/payroll/cutoff-type/ContainerView'),
      SetupPayrollDoeContainerView: () => import('@/components/hris/setup/payroll/doe/ContainerView'),
      SetupPayrollContributionOrDeductionContainerView: () => import('@/components/hris/setup/payroll/contribution-or-deduction/ContainerView'),
      SetupPayrollTaxExemptionContainerView: () => import('@/components/hris/setup/payroll/tax-exemption/ContainerView'),
      SetupPayrollBikContainerView: () => import('@/components/hris/setup/payroll/bik/ContainerView'),
      SetupPayrollPerquisiteContainerView: () => import('@/components/hris/setup/payroll/perquisite/ContainerView'),
      SetupPayrollVolaContainerView: () => import('@/components/hris/setup/payroll/vola/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Payroll Setups',
      }
    },
    data () {
      return {
        tabItems: [ ],
        active: null,
      }
    },

    computed: {   
      filteredTabItems () {
        let modifiedTab = [...this.tabItems]
 
        if (this.$hasPermissionTo(['view payroll cycles'])) {
          modifiedTab.push({ name: 'Payroll Cycle' })
        }
        if (this.$hasPermissionTo(['view payroll banks'])) {
          modifiedTab.push({ name: 'Payroll Bank' })
        }

        if (this.$hasPermissionTo(['view contribution or deductions'])) {
          modifiedTab.push({ name: 'COD' })
        }

        if (this.$hasPermissionTo(['view tax exemptions'])) {
          modifiedTab.push({ name: 'Tax Exemptions' })
        }

        if (this.$hasPermissionTo(['view tax reliefs'])) {
          modifiedTab.push({ name: 'Tax Relief' })
        }

        if (this.$hasPermissionTo(['view cut off types'])) {
          modifiedTab.push({ name: 'Cutoff Type' })
        }

        if (this.$hasPermissionTo(['view DoEs'])) {
          modifiedTab.push({ name: 'DOE' })
        }

        if (this.$hasPermissionTo(['view benefit in kinds'])) {
          modifiedTab.push({ name: 'BIK' })
        }

        if (this.$hasPermissionTo(['view perquisites'])) {
          modifiedTab.push({ name: 'Perquisite' })
        }
        
        if (this.$hasPermissionTo(['view volas'])) {
          modifiedTab.push({ name: 'VOLA' })
        }
        
        return modifiedTab
      },
    },
  }
</script>

<style scoped>
.divider { 
  border-right: 1px solid #707070;
  border-bottom: 1px solid #707070;
} 

.font-black{
  color:black !important;
}

.divider.font-black.v-tab.v-tab--active{
  border-bottom:0px;
}

.v-tab {
  text-transform: none !important;
  max-height: 33px;
}
</style>
